const UserGetter = {
    user: (state) => state.user,
    users: (state) => state.users,
    auth: (state) => state.auth,
    userProfile: state => state.userProfile,
    nextOfKins: state => state.nextOfKins
};

export default UserGetter;